import * as React from "react";
import { Button } from "~/components/button";
import { Dialog } from "~/components/dialog";
import { useToasts } from "~/components/toasts/toasts";
import { axiosInstance } from "~/lib/axios-instance";

export const useConfirmLogoutDialog = () => {
  const [showConfirmLogoutDialog, setShowConfirmLogoutDialog] =
    React.useState<boolean>(false);

  const ConfirmLogoutDialog = React.useCallback(() => {
    const [status, setStatus] = React.useState<"idle" | "loading" | "success">(
      "idle",
    );
    const { addToast } = useToasts();

    const logOut = async () => {
      setStatus("loading");
      try {
        await axiosInstance.delete("/api/v0/session");
        setStatus("success");
        setTimeout(() => setShowConfirmLogoutDialog(false), 0);
        window.location.href = "/";
      } catch (e) {
        addToast({
          variant: "error",
          content: "An error occurred. Please try again.",
        });
        setStatus("idle");
      }
    };

    return (
      <Dialog
        showDialog={showConfirmLogoutDialog}
        setShowDialog={setShowConfirmLogoutDialog}
        preventDefaultClose
      >
        <Dialog.Header icon="log-out-01">
          <Dialog.Title>Log out?</Dialog.Title>
        </Dialog.Header>
        <Dialog.Content>
          <p className="text-sm">Are you sure you want to log out?</p>
        </Dialog.Content>
        <Dialog.Footer>
          <Button
            variant="outline"
            onClick={() => setShowConfirmLogoutDialog(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            iconPrefix="log-out-01"
            onClick={() => logOut()}
            loading={status === "loading"}
          >
            Log out
          </Button>
        </Dialog.Footer>
      </Dialog>
    );
  }, [showConfirmLogoutDialog, setShowConfirmLogoutDialog]);

  return React.useMemo(
    () => ({ setShowConfirmLogoutDialog, ConfirmLogoutDialog }),
    [setShowConfirmLogoutDialog, ConfirmLogoutDialog],
  );
};
